module.exports = __webpack_public_path__ + "img/13_Middle-D.c147c8a1.png";